<template>
  <div class="pagenavi">
    당해 연도 원천세 신고자료를 인증서를 입력하여 조회하는 제출 방법입니다.
    <br /><br />
    <b>입력한 인증서 정보는 조회 시에만 사용되며, 별도로 저장되지 않습니다.</b>
    <br /><br />
  </div>
  <div v-if="props.prsntAt" class="layer-btn">
    <btn :txt="'인증서 수정하기'"
         :color="'purple'"
         @click="btnRgst_click"/>
  </div>
  <div v-else class="layer-btn">
    <btn :txt="'다음에 하기'"
         :color="'white'"
         @click="btnCancl_click"/>
    <btn :txt="'인증서 조회'"
         :color="'purple'"
         @click="btnRgst_click"/>
  </div>
</template>

<script setup>
import {defineProps, defineEmits} from "vue";
import {getUtils} from "@/utils/import";
const {$alert} = getUtils();

const props = defineProps({
  prsntAt: {
    type: Boolean,
    required: true
  }
})
const emits = defineEmits(['rgst', 'close']);

const btnCancl_click = () => {
  $alert('과거 신고자료를 제출하여, 당해 연도에 신고한 원천세 신고자료에 대한 오류검증을 진행합니다. <br /><br /> 다음에 하실 경우에는 포털 > 시설/서비스 > 서비스신청내역 > [과거세무신고자료]에서 제출 가능합니다.')
  emits('close');
}

const btnRgst_click = () => {
  emits('rgst');
  emits('close');
}
</script>

<style scoped>

</style>
